import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Header } from '@/widgets/header';
import type { QueryClient } from '@tanstack/react-query';
import { ScrollToTop } from '@/shared/ui/ScrollToTop';
import { Footer } from '@/widgets/footer';
import { AlertDialogProvider } from '@/app/providers/AlertDialogProvider';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  isLoggedIn: boolean;
}>()({
  component: RootComponent,
});

export default function RootComponent() {
  return (
    <AlertDialogProvider>
      <div className='min-h-screen flex flex-col'>
        <ScrollToTop />
        <Header />
        <main className='flex-1 mt-14 md:mt-16'>
          <Outlet />
        </main>
        <Footer />
      </div>
    </AlertDialogProvider>
  );
}
